/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _errorBox = __webpack_require__(1);
	
	var _errorBox2 = _interopRequireDefault(_errorBox);
	
	var _successBox = __webpack_require__(2);
	
	var _successBox2 = _interopRequireDefault(_successBox);
	
	var _successBoxEscrow = __webpack_require__(3);
	
	var _successBoxEscrow2 = _interopRequireDefault(_successBoxEscrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(document).ready(function () {
	    /*--------------------------------------*/
	    function receiveMessage(event) {
	        var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
	        var theme_color = event.data.theme_color;
	        $(".send-btn").css("background-color", theme_color);
	
	        function injectStyles(rule) {
	            $('<style>' + rule + '</style>').appendTo("body");
	        }
	
	        injectStyles('.mdl-textfield__label:after { background-color: ' + theme_color + '; }');
	        injectStyles('.send-btn:hover { opacity: 0.9;');
	    }
	
	    window.addEventListener("message", receiveMessage, false);
	    /*--------------------------------------*/
	
	    var form_processing = false;
	    var formElement = $("#offer-form");
	    var formTemplate = $("body");
	
	    var props = {};
	
	    var match,
	        pl = /\+/g,
	        // Regex for replacing addition symbol with a space
	    search = /([^&=]+)=?([^&]*)/g,
	        decode = function decode(s) {
	        return decodeURIComponent(s.replace(pl, " "));
	    },
	        query = window.location.search.substring(1);
	    while (match = search.exec(query)) {
	        props[decode(match[1])] = decode(match[2]);
	    } //        fix size
	    // var iframe = $('#' + props.id + ' #iframe', parent.document.body);
	    // iframe.height($(document.body).height() + 20);
	    window.parent.postMessage({
	        height: $(document.body).height() + 20,
	        type: 'fixSize',
	        popupId: props.id
	    }, "*");
	    //////////////////////////////////////////////////////////
	
	    if (props.domainName) formElement.find('#domain_for').val(props.domainName);
	    props.domainName = props.domainName || "this domain";
	
	    ['template_id', 'template_source'].forEach(function (paramName) {
	        if (props[paramName]) {
	            var formInput = formElement.find('#' + paramName);
	            if (formInput) {
	                formInput.val(props[paramName]);
	            }
	        }
	    });
	    if (props.minOfferAmount) {
	        formElement.find('#form-price').val(props.minOfferAmount);
	    }
	
	    var requiredFields = $('.will_required');
	    formTemplate.find("#submitButton").unbind().click(function (e) {
	        requiredFields.each(function () {
	            $(this).prop('required', true);
	        });
	        formElement.submit();
	    });
	
	    //////////////////////////////////////////////////////////
	
	    $('#offer-form').on('submit', function (e) {
	        function initLoading() {
	            form_processing = true;
	            formElement.addClass("processing");
	            formElement.find('.sendButton').addClass('disabled');
	            $('.send_btn_text').css({ display: "none" });
	            $('.loading_icon').css({ display: "inline" });
	        }
	        function endLoading() {
	            form_processing = false;
	            window.parent.postMessage(props.id, "*");
	            formElement.removeClass("processing");
	            formElement.find('.sendButton').removeClass('disabled');
	        }
	        if (form_processing) {
	            return;
	        }
	        if (Array.from(requiredFields).every(function (el) {
	            return $(el).val() !== "";
	        })) {
	            initLoading();
	            e.preventDefault();
	            grecaptcha.ready(function () {
	                grecaptcha.execute(("6LdbcaMZAAAAADuuBHXDqmn80oD70v3C-_6yDJdu"), { action: 'popupform' }).then(function (token) {
	                    if (token) {
	                        var data = formElement.serializeArray(); // convert form to array
	                        data.push({ name: "userId", value: props.userId });
	                        data.push({ name: "token", value: token });
	
	                        $.ajax({
	                            type: "POST",
	                            url: ("https://api.wildcardparking.com/v1/mail/send"),
	                            data: $.param(data),
	                            success: function success(data) {
	                                var originalForm = formElement.detach();
	                                $('.send_btn_text').css({ display: "inline" });
	                                $('.loading_icon').css({ display: "none" });
	                                if (data.escrow) {
	                                    formTemplate.html(_successBoxEscrow2.default);
	                                } else {
	                                    formTemplate.html(_successBox2.default);
	                                }
	                            },
	                            error: function error() {
	                                var originalForm = formElement.detach();
	                                formTemplate.html(_errorBox2.default);
	                                formTemplate.find("a.close").click(function () {
	                                    formTemplate.html(originalForm);
	                                });
	                            },
	                            complete: endLoading
	                        });
	                    } else {
	                        endLoading();
	                    }
	                });
	            });
	        } else {
	            requiredFields.each(function () {
	                if ($(this).val() === "") {
	                    $(this).closest('.mdl-textfield').addClass('is-invalid');
	                }
	            });
	        }
	    });
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = "<div class=\"alert alert-danger fade in\"> <a href=# class=close data-dismiss=alert aria-label=close title=close>×</a> <strong>server error occurred!</strong> You offer haven't successfully sent, please contact our tech support via <a href=mailto:support@wildcardparking.com>support@wildcardparking.com</a> </div>";

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = "<div class=\"alert alert-success\"> <strong>Success!</strong> Your message has been successfully sent. </div>";

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = "<div class=\"alert alert-success\"> <strong>Success!</strong> Please check the email to follow further instructions from escrow.com </div>";

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** form.bundle.js
 **/